import Code from 'models/Code';
import { observable } from 'mobx';
import { serialize, deserialize } from 'serializers/EtsngCode';

export default class EtsngCode extends Code {

  @observable additional_dues
  @observable advice
  @observable budget_classification
  @observable certification
  @observable classification_certificate
  @observable code
  @observable comments
  @observable notes
  @observable classification_comments
  @observable customs_laboratoris
  @observable description
  @observable dual_use_goods
  @observable duty
  @observable free_trade_zone_agreements
  @observable duty_sng
  @observable excise_dues
  @observable excise_duty_marks
  @observable export_dues
  @observable filling_instruction
  @observable licence
  @observable ondate
  @observable quota
  @observable short_description
  @observable tariff_preference
  @observable unit_name
  @observable vat
  @observable to_date
  @observable id
  @observable parent
  @observable tnved

  parse(json) {
    return deserialize(json);
  }

  toJSON() {
    return serialize(this);
  }

}



// WEBPACK FOOTER //
// ./src/models/EtsngCode.js